import { Injectable } from "@angular/core";
import { Subject, Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
// import { HttpClient } from "@angular/common/http";
import { ContextRoot, HttpWrapperService } from '@util-services/http-wrapper/http-wrapper.service';
import { OnDestroy } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { StorageService } from "../storage.service";
import { isEmptyString, isEmptyValue } from '@helpers';

export function componentDestroyed(component: OnDestroy) {
  const oldNgOnDestroy = component.ngOnDestroy;
  const destroyed$ = new ReplaySubject<void>(1);
  component.ngOnDestroy = () => {
    oldNgOnDestroy.apply(component);
    destroyed$.next(undefined);
    destroyed$.complete();
  };
  return destroyed$;
}

export interface VeldenMappen {
  verplichteVeldenMap: Map<string, boolean>;
  toevoegbareVeldenMap: Map<string, boolean>;
  verwijderbareVeldenMap: Map<string, boolean>;
  wijzigbareVeldenMap: Map<string, boolean>;
  disabledVeldenMap: Map<string, boolean>;
  verborgenVeldenMap: Map<string, boolean>;
}

type BooleanMap = Map<string, boolean>;

export interface ActionIdentifier {
  actionIdentifier: string;
  type: string;
  kolomNaam: string;
  tabelNaam: string;
  prompt: string;
  flexkenmerk: string;

  hidden: boolean;
  wijzigbaar: boolean;
  verplicht: boolean;

  kolomlengte: number; // Integer
  kolomdecimalen: number; // Integer
  veldId: number; // int
  kolomtype: string;
  informatie: string;
}

export type ActionIdentifierMap = Map<string, ActionIdentifier>;

export type ApiValueType = boolean | number | string | Date;
export type ApiValueTypeMap = Map<string, ApiValueType>;

export class BrowserDetect {
  browser: any;
  version: any;
  versionSearchString: any;

  dataBrowser = [
    { string: navigator.userAgent, subString: "Edge", identity: "Edge" },
    { string: navigator.userAgent, subString: "MSIE", identity: "IE" },
    { string: navigator.userAgent, subString: "Trident", identity: "IE" },
    { string: navigator.userAgent, subString: "Firefox", identity: "Firefox" },
    { string: navigator.userAgent, subString: "Opera", identity: "Opera" },
    { string: navigator.userAgent, subString: "OPR", identity: "Opera" },
    { string: navigator.userAgent, subString: "Chrome", identity: "Chrome" },
    { string: navigator.userAgent, subString: "Safari", identity: "Safari" },
  ];

  init() {
    this.browser = this.searchString(this.dataBrowser) || "Other";
    this.version =
      this.searchVersion(navigator.userAgent) ||
      this.searchVersion(navigator.appVersion) ||
      "Unknown";
  }

  searchString(data) {
    for (let i = 0; i < data.length; i++) {
      let dataString = data[i].string;
      this.versionSearchString = data[i].subString;

      if (dataString.indexOf(data[i].subString) !== -1) {
        return data[i].identity;
      }
    }
  }

  searchVersion(dataString) {
    let index = dataString.indexOf(this.versionSearchString);
    if (index === -1) {
      return;
    }

    let rv = dataString.indexOf("rv:");
    if (this.versionSearchString === "Trident" && rv !== -1) {
      return parseFloat(dataString.substring(rv + 3));
    } else {
      return parseFloat(
        dataString.substring(index + this.versionSearchString.length + 1)
      );
    }
  }
}

@Injectable()
export class ApplicationUtilsService {
  private veldenMappen: VeldenMappen = {} as VeldenMappen; // SectorToegestaneActies
  private veldenMappen$ = new ReplaySubject<VeldenMappen>(1);

  private verplichteVelden: any = null;
  private toevoegbareVelden: any = null;
  private verwijderbareVelden: any = null;
  private wijzigbareVelden: any = null;

  private sectorParams = new Subject<any>();
  private sectorParamsObservable = this.sectorParams.asObservable();

  private actionIdentifierMap: ActionIdentifierMap;

  private prompts;
  private sectorParameters;
  private actionIdentifiers;

  private loggedInUser: any;

  private appversion;
  private hostname;
  private beheermodus: boolean;
  private dbOmgeving;
  private dbOmgevingKleur;

  private initStatusses = [];
  private initStatussesHandelingenCount = 1;
  private certificaatNummer = "";
  private landVanAfgifte = "";
  private datumVanAfgifte;
  private captchaInput = "";
  private resultaten;
  private resultatenOpgehaald = false;
  private resultaatError = null;

  private browser;

  public readonly POSITIVE_BTN = "positive";
  public readonly NEGATIVE_BTN = "negative";
  public readonly CLOSE_BTN = "close";
  public readonly BACKGROUND = "background";
  private errorMessage = {
    foutmelding: "",
    headerFoutmelding: "",
    foutmeldingOverig: "",
  };

  private readonly contextRoot: string;

  constructor(
    private cleHttp: HttpWrapperService,
    // private httpClient: HttpClient,
    private localstorage: StorageService
  ) {
    this.contextRoot = ContextRoot;
  }

  getErrorMessage() {
    this.errorMessage.foutmelding = this.getPrompt(
      "DOWNLOAD_EPHYTO.ERROR_ALG_TEKST"
    );
    this.errorMessage.headerFoutmelding = this.getPrompt(
      "DOWNLOAD_EPHYTO.ERROR_ALG_HEADER"
    );
    this.errorMessage.foutmeldingOverig = this.getPrompt(
      "DOWNLOAD_EPHYTO.ERROR_OVERIG"
    );
    return this.errorMessage;
  }

  getContextRoot(): string {
    return this.contextRoot;
  }

/*
  instantiateLogedInUser(): Observable<any> {
    return this.httpClient
      .post("/" + this.getContextRoot() + "/getLoggedInUser", null)
      .pipe(
        map((res: any) => {
          this.loggedInUser = res;
        }),
        catchError((error: any) => {
          return Observable.throw("Kon de applicatie niet initieren");
        })
      );
  }
*/

  // prompts ophalen waarbij key=action-identifier en value=prompts
  private syncprompts(language: string): Observable<any> {
    return this.cleHttp.post("/" + this.getContextRoot() + '/getPrompts', {
        eigenschap: "prompt",
        taal: language,
      })
      .pipe(
        map((res: any) => {
          this.prompts = this.getEphytoPrompts(res, "DOWNLOAD_EPHYTO", "MELDINGEN");
        }),
        catchError((error: any) => {
          return Observable.throw("Kon de applicatie niet initieren");
        })
      );
  }

  getEphytoPrompts(prompts, type: string, type2: string) {
    const ephytoPrompts = {};
    for (const value of Object.keys(prompts)) {
      if (value.startsWith(type) || value.startsWith(type2)) {
        ephytoPrompts[value] = prompts[value];
      }
    }
    return ephytoPrompts;
  }

/*
  getEphytoPromptsOld(prompts: any) {
    const ephytoPrompts = [];
    prompts.forEach((prompt) => {
      if (prompt != null && prompt.subString(1, 15) === "DOWNLOAD_EPHYTO") {
        ephytoPrompts.push(prompt);
      }
    });
    return ephytoPrompts;
  }
*/

  public getPrompt(value) {
    if (
      typeof this.prompts[value] == "undefined" ||
      this.prompts[value] == null ||
      this.prompts[value] == ""
    ) {
      return value;
    }
    return this.prompts[value];
  }

  public getActionIdentifier(value) {
    if (
      typeof this.actionIdentifiers[value] == "undefined" ||
      this.actionIdentifiers[value] == null ||
      this.actionIdentifiers[value] == ""
    ) {
      return value;
    }
    return this.actionIdentifiers[value];
  }

  getActionIdentifierObject(value: string): ActionIdentifier {
    const actionIdentifier = this.actionIdentifierMap[value];

    if (isEmptyValue(actionIdentifier)) {
      return { actionIdentifier: value } as ActionIdentifier;
    }
    return actionIdentifier;
  }

  getLength(value: string): number | string {

/*
    const kolomlengte = this.actionIdentifierMap[value] == null ? null : this.actionIdentifierMap[value].kolomlengte;
    if (isEmptyString(kolomlengte) || kolomlengte === 0) {
      return value;
    }
    return kolomlengte;
*/


    let kolomlengte;
    if (!isEmptyValue(this.actionIdentifierMap)) {
      kolomlengte = this.actionIdentifierMap[value] == null ? null : this.actionIdentifierMap[value].kolomlengte;

      if (isEmptyString(kolomlengte) || kolomlengte === 0) {
        return value;
      }
    return kolomlengte;
    }
  }

  public async load() {
    return new Promise((resolve, reject) => {
      this.prompts = null;
      this.actionIdentifiers = null;

      this.syncprompts("EN")
        .pipe(
          catchError((error: any): any => {
            if (this.processInitResult(false)) {
              this.getInitResult(resolve, reject, error);
            }
          })
        )
        .subscribe((callResult) => {
          if (this.processInitResult(true)) {
            this.getInitResult(resolve, reject, null);
          }
        });
    });
  }

  processInitResult(status) {
    this.initStatusses.push(status);
    return this.initStatusses.length == this.initStatussesHandelingenCount;
  }

  private getInitResult(resolve, reject, error) {
    let result = true;
    for (let index = 0; index < this.initStatusses.length; index++) {
      result = result && this.initStatusses[index];
    }
    result =
      result && this.initStatusses.length == this.initStatussesHandelingenCount;
    if (result) {
      // this.browserCheck(resolve, reject);
      resolve(true);
    } else {
      reject(false);
    }
  }

  public getLoggedInUser() {
    return this.loggedInUser;
  }

  public getdbOmgeving() {
    return this.dbOmgeving;
  }

  public getdbOmgevingKleur() {
    return this.dbOmgevingKleur;
  }

  getKolomActie(kolomIdentificatie: string, kolomActie: string) {
    switch (kolomActie) {
      case "verplicht":
        if (typeof this.verplichteVelden[kolomIdentificatie] != "undefined") {
          return this.verplichteVelden[kolomIdentificatie];
        } else {
          return false;
        }
      case "wijzigbaar":
        if (!isEmptyValue(this.wijzigbareVelden) && typeof this.wijzigbareVelden[kolomIdentificatie] != "undefined") {
          return this.wijzigbareVelden[kolomIdentificatie];
        } else {
          return false;
        }
      case "toevoegen":
        if (typeof this.toevoegbareVelden[kolomIdentificatie] != "undefined") {
          return this.toevoegbareVelden[kolomIdentificatie];
        } else {
          return false;
        }
      case "verwijderen":
        if (
          typeof this.verwijderbareVelden[kolomIdentificatie] != "undefined"
        ) {
          return this.verwijderbareVelden[kolomIdentificatie];
        } else {
          return false;
        }
      case "verbergen":
        if (typeof this.verborgenVelden[kolomIdentificatie] != "undefined") {
          return this.verborgenVelden[kolomIdentificatie];
        } else {
          return false;
        }
      default:
        return null;
    }
  }

  public getVersion() {
    return this.appversion;
  }

  public getHostname() {
    return this.hostname;
  }

  public getBeheermodus() {
    return this.beheermodus;
  }

  public getSectorParameter(param) {
    if (
      typeof this.sectorParameters[param] == "undefined" ||
      this.sectorParameters[param] == null ||
      this.sectorParameters[param] === ""
    ) {
      return null;
    }
    return this.sectorParameters[param];
  }

  getMimeType(extensie: string) {
    extensie = extensie.toLowerCase();
    switch (extensie) {
      case "xml":
        return "application/xml";
      case "pdf":
        return "application/pdf";
      case "doc":
        return "application/msword";
      case "docx":
        return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      case "xls":
        return "application/vnd.ms-excel";
      case "xlsx":
        return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      case "jpg":
      case "jpeg":
        return "image/jpeg";
      case "png":
        return "image/png";
    }
  }

  isDisabled(ref_object: any, action_identifier: string) {
    let wijzigbaar: boolean = false;
    if (action_identifier != undefined) {
      wijzigbaar = this.getKolomActie(action_identifier, "wijzigbaar");
    }

    if (
      ref_object == undefined ||
      typeof ref_object.muteerbaar == "undefined"
    ) {
      return false;
    } else {
      return !ref_object.muteerbaar || (ref_object.eedOpSlot && !wijzigbaar);
    }
  }

  compareObjects(o, o2) {
    if (o == null || o2 == null) {
      return false;
    }
    const aantalkeys1 = Object.keys(o).length;
    const aantalkeys2 = Object.keys(o2).length;

    if (aantalkeys1 != aantalkeys2) {
      return false;
    }
    let returnvalue = true;
    Object.keys(o).forEach((k) => {
      let itsAMatch = o[k] == o2[k];

      if (
        o[k] != null &&
        typeof o[k] == "object" &&
        o2[k] != null &&
        typeof o2[k] == "object"
      ) {
        itsAMatch = JSON.stringify(o[k]) == JSON.stringify(o2[k]);
      }

      returnvalue = returnvalue && itsAMatch;
    });
    return returnvalue;
  }

  getCertificaatNummer() {
    return this.certificaatNummer;
  }

  setCertificaatNummer(certificationNumber: string) {
    this.certificaatNummer = certificationNumber;
  }

  getLandVanAfgifte() {
    return this.landVanAfgifte;
  }

  setLandVanAfgifte(landVanAfgifte: string) {
    this.landVanAfgifte = landVanAfgifte;
  }

  getDatumVanAfgifte() {
    return this.datumVanAfgifte;
  }

  setDatumVanAfgifte(datumVanAfgifte: Date) {
    this.datumVanAfgifte = datumVanAfgifte;
  }

  getCaptchaInput() {
    return this.captchaInput;
  }

  setCaptchaInput(captchaInput: string) {
    this.captchaInput = captchaInput;
  }

  getResultaten() {
    return this.resultaten;
  }

  setResultaten(resultaten: any) {
    this.resultaten = resultaten;
  }

  isResultatenOpgehaald() {
    return this.resultatenOpgehaald;
  }

  setResultatenOpgehaald(resultatenOpgehaald: boolean) {
    this.resultatenOpgehaald = resultatenOpgehaald;
  }

  getResultaatError() {
    return this.resultaatError;
  }

  setResultaatError(resultaatError: any) {
    this.resultaatError = resultaatError;
  }

  getVeldenMappenObservable(): Observable<VeldenMappen> {
    return this.veldenMappen$.asObservable();
  }

  get verborgenVelden(): BooleanMap {
    return this.veldenMappen.verborgenVeldenMap;
  }

  isKolomActieVerplicht(actionIdentifier): boolean {
    return this.getKolomActie(actionIdentifier, 'verplicht');
  }

  isKolomActieVerbergen(actionIdentifier): boolean {
    return this.getKolomActie(actionIdentifier, 'verbergen');
  }

  public getBrowser() {
    return this.browser;
  }

  gebruikDrieDecimalen(): boolean {
    const gebruikDrieDecimalen = this.getSectorParameter('GEBRUIK_DRIE_DECIMALEN') as boolean;
    return gebruikDrieDecimalen == null ? false : gebruikDrieDecimalen;
  }

  formatValueBeforeScreen(value: ApiValueType): string {
    // Decimale punt uit de database tonen als een komma op het scherm.
    // En een punt op het scherm tonen bij duizend-tallen.

    const searchValue = /\B(?=(\d{3})+(?!\d))/g;

    if (!isEmptyValue(value)) {
      const valueString = value.toString();
      if (valueString.includes('.')) {
        // Getal bevat een decimale punt. Deze omzetten naar decimale komma op het scherm.
        const splitResult = valueString.split('.');
        splitResult[0] = splitResult[0].replace(searchValue, '.');

        if (this.gebruikDrieDecimalen()) {
          // Bij mogelijkheid van drie decimalen ook tot drie decimalen aanvullen met nullen.
          switch (splitResult[1].length) {
            case 0:
              splitResult[1] = splitResult[1] + '000';
              break;
            case 1:
              splitResult[1] = splitResult[1] + '00';
              break;
            case 2:
              splitResult[1] = splitResult[1] + '0';
              break;
          }
        }
        return splitResult.join(',');
      } else {
        return valueString.replace(searchValue, '.');
      }
    }
    return value as string;
  }

}
